import { Typography, Box } from '@mui/material';

function Home() {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        minHeight: '100vh',
        backdropFilter: 'blur(5px)',
      }}
    >
      {/* Top text section */}
      <Box
        sx={{
          px: 4,
          pt: 2,   // move text closer to top
          pb: 4,
          textAlign: 'center',
        }}
      >
        <Typography variant="h3" color="primary" gutterBottom>
          Russo Excavating
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Supporting Colorado Communities Since 2019.
        </Typography>
      </Box>

      {/* Full-width image */}
      <Box
        component="img"
        src="https://res.cloudinary.com/dtdase4ev/image/upload/f_auto,q_auto/v1771871759/FullSizeRender_alvdob"
        alt="Russo Excavating equipment"
        sx={{
          width: '100vw',          // edge-to-edge
          height: { xs: 300, sm: 400, md: 500 }, // larger hero feel
          objectFit: 'cover',
          display: 'block',
        }}
      />

      {/* Bottom text section */}
      <Box
        sx={{
          px: 4,
          py: 4,
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" color="primary" gutterBottom>
          Service Offering
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Excavation, Utility Installation, Grading, Site Preparation
        </Typography>
      </Box>
    </Box>
  );
}

export default Home;